import type { CardGroup } from 'API';

export type GetGroupPaidolUsersQuery = {
  listCardGroupsByPaidolId?: {
    __typename: 'ModelCardGroupConnection';
    items: Array<CardGroup>;
    nextToken?: string | null;
  } | null;
};

export const GetGroupPaidolUsers = /* GraphQL */ `
  query GetGroupPaidolUsers($paidolId: ID!, $nextToken: String, $limit: Int = 100) {
    listCardGroupsByPaidolId(
      paidolId: $paidolId
      nextToken: $nextToken
      filter: { deletedAt: { attributeExists: false } }
    ) {
      nextToken
      items {
        id
        name
        spendGroupId
        authPaidolId
        isMonthlyBudgetUnlimited
        paymentCards(limit: $limit) {
          items {
            paymentCardId
            paidolUsers {
              items {
                paidolUser {
                  user_id
                  id
                  email
                  roles
                  user {
                    id
                    first_name
                    last_name
                    picture
                    email
                  }
                }
              }
            }
          }
        }
        groupAdmins {
          items {
            paidolUser {
              user_id
              id
              email
              roles
              user {
                id
                first_name
                last_name
                picture
                email
              }
            }
          }
        }
        monthlyBudget {
          currency
          value
        }
        monthlyBudgetSpend(sortDirection: DESC) {
          items {
            amount
            yearAndMonth
          }
        }
      }
    }
  }
`;
